/*eslint no-mixed-spaces-and-tabs: */
import CryptoJS from 'crypto-js'

export const cryptoMixin = {
	  data: function() {
		return {
		  pass:"freeway-alley-ALPACA-claque",
		  iv:"9afe9edb8cca4529b45a17a022aff1b8",
		  salt:"coh2tmyRhHzBdFawd3K_UMPEY"
		};
	  },
	  methods: {
		decryptString: function(value){
			var encryptData = value;
			
			try {
				//Creating the Vector Key
				var Iv = CryptoJS.enc.Hex.parse("9afe9edb8cca4529b45a17a022aff1b8");
				//Encoding the Password in from UTF8 to byte array
				var Pass = CryptoJS.enc.Utf8.parse("freeway-alley-ALPACA-claque");
				//Encoding the Salt in from UTF8 to byte array
				var Salt = CryptoJS.enc.Utf8.parse("coh2tmyRhHzBdFawd3K_UMPEY");
				//Creating the key in PBKDF2 format to be used during the decryption
				var key128Bits1000Iterations = CryptoJS.PBKDF2(Pass.toString(CryptoJS.enc.Utf8), Salt, { keySize: 128 / 32, iterations: 1000 });
				//Enclosing the test to be decrypted in a CipherParams object as supported by the CryptoJS library
				var cipherParams = CryptoJS.lib.CipherParams.create({
					ciphertext: CryptoJS.enc.Base64.parse(encryptData)
				});
	
				//Decrypting the string contained in cipherParams using the PBKDF2 key
				var decrypted = CryptoJS.AES.decrypt(cipherParams, key128Bits1000Iterations, { mode: CryptoJS.mode.CBC, iv: Iv, padding: CryptoJS.pad.Pkcs7 });
				var result = decrypted.toString(CryptoJS.enc.Utf8);
				return result;
			}
			//Malformed UTF Data due to incorrect password
			catch (err) {
				console.log ({ err })
				return "";
			}
		}
	  }
	};
	